import React from 'react';
import PropTypes from 'prop-types';
import * as icons from 'mdi-material-ui';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
`;

const OnlineBadge = ({ online }) => {
    return (
        <icons.Circle
            sx={{
                fontSize: '16px',
                verticalAlign: 'baseline',
                color: online ? 'success.main' : 'error.main',
                animation: online ? `${pulse} 1.5s infinite` : 'none',
                borderRadius: '50%',
                display: 'inline-block',
            }}
        />
    );
};

OnlineBadge.propTypes = { online: PropTypes.bool.isRequired };

export default OnlineBadge;
